import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import _ from 'lodash';
import UserAdmin from './userAdmin/UserAdmin';
import ProjectAdmin from './projectAdmin/ProjectAdmin';
import SelectInput from './../../../../components/SelectInput';
import Spinner from './../../../../components/Spinner';
import CustomerAdmin from './customerAdmin/CustomerAdmin';
import InstanceAdmin from './instanceAdmin/InstanceAdmin';
import loading from './../../../../utilities/loading';
import ProjectAttributes from './projectAttributesAdmin/ProjectAttributes';
import LogoDropZone from './../../logo/LogoDropZone';
import ReactSVG from 'react-svg';
import WorkspaceIcon from './../../../../icons/workspace.svg';
import StatisticIcon from './../../../../icons/visible.svg';
import UserIcon from './../../../../icons/user.svg';
import CustomerIcon from './../../../../icons/customer.svg';
import AttributeIcon from './../../../../icons/attributes.svg';
import InstancesIcon from './../../../../icons/instances.svg';
import IconEdit from './../../../../icons/edit.svg';
import messageManager from './../../../../utilities/messageManager';
import shadeColor from './../../../../utilities/shadeColor';
import IconClose from './../../../../icons/cancel2.svg';
import { modalInstance } from './../../../admin/Admin';
import DefaultButton from './../../../../components/DefaultButton';
import TextInput from './../../../../components/TextInput';
import UserAssigmentAdmin from './userAssignmentAdmin/UserAssigmentAdmin';

const AdminWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const AdminHeader = styled.div`
    padding: 10px;
    background: linear-gradient(0deg, #263650 100%, #082242 100%);
    color: #ffffff;
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
`;

const AdminHeaderTitle = styled.div`
    font-weight: bold;
`;

const CustomerSelectionWrapper = styled.div`
    display: flex;
    float: left;
    align-items: center;
    > div {
        margin-left: 5px;
    };
`;

const LogoWrapper = styled.div`
    width: 200px;
    max-height: 200px;
    min-height: 36px;
    input {
        width: 200px;
    };
`;

const AdminBody = styled.div`
    display: flex;
    overflow: auto;
`;

const AdminSide = styled.div`
    width: 144px;
    align-items: center;
    justify-content: center;
    background: #265a9c;
    overflow-y: auto;
`;

const SideButton = styled.div`
    display: ${props => props.visible ? "flex" : "none"};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 120px;
    margin: 10px;
    color: white;
    cursor: pointer;
    border: 1.5px solid #8080801a;
    border-radius: 5px;
    :hover {
        background-color: ${ shadeColor('#265a9c', 0.2)} ;
    };
    pointer-events: ${props => props.disabled ? 'none' : 'auto'};   
    cursor: ${props => props.disabled ? 'default' : 'pointer'};   
    background-color: ${props => props.disabled ? shadeColor('#265a9c', 0.5) : '#265a9c'};
`;

const StyledReactSVG = styled(ReactSVG)`
    fill: #ffffff;
    padding: 5px;
    width: 30px;
    height: 30px;
`;

const AdminContent = styled.div`
    width: calc(100% - 146px);
    background-color: #ffffff;
    overflow-y: auto;
`;

const StyledSpinner = styled(Spinner)`
    position: relative;
`;

const PanelHeader = styled.div`
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: white;
    background-color: #265a9c;
`;

const PanelWrapper = styled.div`
    width: calc(100% - 80px);
    margin: 40px;
`;

const LogoDeleteButton = styled.div`
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 2;
    border-radius: 5px;  
    width: 20px;
    display: flex;
    justify-content: center;
    background: #ffffff80;
    :hover {
        box-shadow: inset 0 0 2px #000000;
    };
`;

const StyledButton = styled(DefaultButton)`
    min-width: 60px;
    font-weight: normal;
    font-size: 15px;
`;

const StyledEditButton = styled(DefaultButton)`
    margin: 0px;
    padding: 5px;
    border-radius: 4px;
`;

class AdminPanel extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            instances: [],
            customers: [],
            users: [],
            projects: [],
            chosenCustomer: null,
            logo: null,
            buttonDisabled: false,
            newCustomerName: "",
            isEditedCustomerName: false,
            userAssignments: []
        };
        this.onLogoFileLoad = this.onLogoFileLoad.bind(this);
    }

    getCustomers() {
        const { BASE_URL, axiosInstance } = this.props;
        const { chosenCustomer } = this.state;
        loading.start();

        axiosInstance.get(`${BASE_URL}customers`)
            .then((response) => {
                const customers = response.data;
                const selectedCustomer = customers.length > 0
                    ? (chosenCustomer === null
                        ? customers[0]
                        : customers.find(customer => {
                            return Number(customer.id) === Number(chosenCustomer.id)
                        }))
                    : null;
                this.setState({
                    customers: customers,
                    chosenCustomer: selectedCustomer,
                    logo: selectedCustomer !== null ? selectedCustomer.logo : null,
                    loading: false,
                });
                loading.stop();
            });
    }

    getInstances() {
        const { BASE_URL, axiosInstance } = this.props;
        loading.start();

        axiosInstance.get(`${BASE_URL}instances`)
            .then((response) => {
                const instancesWithoutLocalhost = response.data
                    .filter(instance => instance.name !== 'localhost');
                this.setState({
                    instances: instancesWithoutLocalhost
                });
                loading.stop();
            });
    }

    getProjects() {
        const { BASE_URL, axiosInstance } = this.props;
        const { chosenCustomer } = this.state;
        if (!chosenCustomer) return;
        loading.start();

        axiosInstance.get(`${BASE_URL}customers/${chosenCustomer.id}/workspaces`)
            .then((response) => {
                this.setState({
                    projects: response.data
                });
                loading.stop();
            });
    }

    getUsers() {
        const { BASE_URL, axiosInstance } = this.props;
        const { chosenCustomer } = this.state;
        if (!chosenCustomer) return;
        loading.start();

        axiosInstance.get(`${BASE_URL}customers/${chosenCustomer.id}/users`)
            .then((response) => {
                this.setState({
                    users: response.data
                });
                loading.stop();
            });
    }

    getUserAssignments() {
        const { BASE_URL, axiosInstance } = this.props;
        loading.start();

        axiosInstance.get(`${BASE_URL}customers/userAssignments`)
            .then((response) => {
                this.setState({
                    userAssignments: response.data
                });
                loading.stop();
            })
            .catch(() => {
                loading.stop();
            });
    }

    getLicenseValidityDescription() {
        const { t } = this.props;
        const { chosenCustomer } = this.state;
        if (!chosenCustomer) return null;

        return chosenCustomer.licenseValid ?
            <div>{t('License expires at')} <b> {chosenCustomer.licenseValidityEnd ? chosenCustomer.licenseValidityEnd.substring(0, 10) : t('Unlimited')} </b></div> :           
            <div style={{color: 'red'}}>{t('License has expired at')} <b>{chosenCustomer.licenseValidityEnd.substring(0, 10)}</b>.<br />
                 {t('To prolong the license contact GISonLine')}<br />email: drononline@gisonline.pl</div>;
    }

    componentDidUpdate(prevProps, prevState) {
        const { chosenCustomer } = this.state;
        if (prevState.chosenCustomer !== chosenCustomer) {
            this.getProjects();
            this.getUsers();
        }
    }

    componentDidMount() {
        this.getCustomers();
        if(this.props.roles === 'SuperAdmin'){
            this.getUserAssignments();
            this.getInstances();
        }
    }

    onLogoFileLoad(imageFile) {
        const { BASE_URL, axiosInstance, t } = this.props;
        const { chosenCustomer } = this.state;
        this.setState({ buttonDisabled: true });

        loading.start();
        const formData: FormData = new FormData();
        formData.append('file', imageFile[0]);
        axiosInstance.put(`${BASE_URL}customers/${chosenCustomer.id}/upload`, formData)
            .then((response) => {
                messageManager.show({
                    type: 'info',
                    text: t('Logo uploaded'),
                })
                this.setState({ buttonDisabled: false });
                this.getCustomers();
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while uploading logo')),
                });
                this.setState({ buttonDisabled: false });
                this.getCustomers();
                loading.stop();
            });
    }

    deleteLogo() {
        const { BASE_URL, axiosInstance, t } = this.props;
        const { chosenCustomer } = this.state;
        this.setState({ buttonDisabled: true });

        const formData: FormData = new FormData();
        formData.append('file', null);
        const confirmCallback = () => {
            axiosInstance.put(`${BASE_URL}customers/${chosenCustomer.id}/upload`, formData)
                .then((response) => {
                    messageManager.show({
                        type: 'info',
                        text: t('Logo was deleted, you will see default logo.'),
                    })
                    this.setState({ buttonDisabled: false });
                    this.getCustomers();
                    loading.stop();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while deleting logo')),
                    });
                    this.setState({ buttonDisabled: false });
                    this.getCustomers();
                    loading.stop();
                });
        }
        const cancelCallback = () => { }

        const config = {
            title: t('Do you really want to delete logo') + '?',
            content: <p>{t('Do you really want to delete logo')}? </p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    editCustomerName() {
        const { BASE_URL, axiosInstance, t } = this.props;
        const { newCustomerName, chosenCustomer } = this.state;

        if (newCustomerName !== '') {
            this.setState({ buttonDisabled: true });
            loading.start();
            const editedCustomer = _.cloneDeep(chosenCustomer);
            editedCustomer.name = newCustomerName;
            editedCustomer.licenseId = chosenCustomer.license.id;
            delete editedCustomer.license;

            axiosInstance.put(`${BASE_URL}customers/${chosenCustomer.id}`, editedCustomer)
                .then(() => {
                    chosenCustomer.name = newCustomerName;
                    this.setState({
                        buttonDisabled: false,
                        newCustomerName: '',
                        isEditedCustomerName: false,
                    });
                    loading.stop();
                    messageManager.show({
                        type: 'info',
                        text: t('Customer edited'),
                    })
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t(error.response.data ? error.response.data : t('Error occured while editing customer')),
                    });
                    this.setState({
                        buttonDisabled: false,
                        newCustomerName: '',
                        isEditedCustomerName: false,
                    })
                    loading.stop();
                });
        }
        else {
            this.setState({
                buttonDisabled: false,
                isEditedCustomerName: false,
            });
        }
    }

    render() {
        const { roles, t } = this.props;
        const { instances, customers, chosenCustomer, users, projects, logo, buttonDisabled, newCustomerName, isEditedCustomerName, userAssignments } = this.state;

        return (
            <AdminWrapper>
                <AdminHeader>
                        <CustomerSelectionWrapper>
                            <AdminHeaderTitle>{t('Administrating')}</AdminHeaderTitle>
                            {roles === 'SuperAdmin'
                                ? <SelectInput
                                    value={chosenCustomer ? chosenCustomer.id : 0}
                                    onChange={(e) => {
                                        const selectedCustomer = customers.find(customer => {
                                            return Number(customer.id) === Number(e.target.value)
                                        })
                                        this.setState({
                                            chosenCustomer: selectedCustomer,
                                            logo: selectedCustomer.logo
                                        });
                                    }}>
                                    {customers.map(customer => {
                                        return (
                                            <option
                                                key={`${customer.id}_customer_option`}
                                                value={customer.id}>
                                                {customer.name}
                                            </option>
                                        )
                                    })}
                                </SelectInput>
                                : this.state.loading
                                    ? null
                                    : <React.Fragment>
                                        <TextInput
                                            disabled={!isEditedCustomerName}
                                            placeholder={chosenCustomer.name}
                                            value={newCustomerName}
                                            onChange={(e) => { this.setState({ newCustomerName: e.target.value }) }}
                                        />
                                        {isEditedCustomerName
                                            ? <React.Fragment>
                                                <StyledButton
                                                    disabled={buttonDisabled}
                                                    onClick={this.editCustomerName.bind(this)}>
                                                    {t('Save')}
                                                </StyledButton>
                                                <StyledButton
                                                    type='warning'
                                                    disabled={buttonDisabled}
                                                    onClick={(e) => {
                                                        this.setState({ newCustomerName: "", isEditedCustomerName: false })
                                                    }}>
                                                    {t('Cancel')}
                                                </StyledButton>
                                            </React.Fragment>
                                            : <StyledEditButton
                                                onClick={(e) => {
                                                    this.setState({ buttonDisabled: false, isEditedCustomerName: true })
                                                }}>
                                                <ReactSVG
                                                    path={IconEdit}
                                                    style={{
                                                        padding: '2px',
                                                        fill: '#ffffff',
                                                        width: '20px',
                                                        height: '20px'
                                                    }}
                                                />
                                            </StyledEditButton>
                                        }
                                    {this.getLicenseValidityDescription()}
                                    </React.Fragment>
                            }
                        </CustomerSelectionWrapper>
                    <LogoWrapper>
                        {logo !== null
                            ? <LogoDeleteButton
                                type='warning'
                                onClick={this.deleteLogo.bind(this)}
                                visible={logo === null ? false : true}
                            >
                                <ReactSVG
                                    path={IconClose}
                                    title={t('Delete logo')}
                                    style={{
                                        fill: '#000000',
                                        width: '10px',
                                        height: '10px',
                                    }} />
                            </LogoDeleteButton>
                            : null
                        }
                        <LogoDropZone
                            onFileLoad={this.onLogoFileLoad}
                            logo={logo}
                            disabled={buttonDisabled} />
                    </LogoWrapper>
                </AdminHeader>
                <AdminBody>
                    <AdminSide>
                        <SideButton
                            disabled={this.state.loading}
                            visible={true}
                            onClick={() => {
                                this.projectTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={WorkspaceIcon} />
                            {t('Projects')}
                        </SideButton>
                        <SideButton
                            disabled={this.state.loading}
                            visible={true}
                            onClick={() => {
                                this.userTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={UserIcon} />
                            {t('Users')}
                        </SideButton>
                        <SideButton
                            disabled={this.state.loading}
                            visible={roles === 'SuperAdmin'}
                            onClick={() => {
                                this.customerTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={CustomerIcon} />
                            {t('Customers')}
                        </SideButton>
                        <SideButton
                            disabled={this.state.loading}
                            visible={roles === 'SuperAdmin'}
                            onClick={() => {
                                this.instancesTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={InstancesIcon} />
                            {t('Instances')}
                        </SideButton>
                        <SideButton
                            disabled={this.state.loading}
                            visible={roles === 'SuperAdmin'}
                            onClick={() => {
                                this.statisticsTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={StatisticIcon} />
                            {t('Statistic')}
                        </SideButton>
                        <SideButton
                            disabled={this.state.loading}
                            visible={true}
                            onClick={() => {
                                this.attributeTab.scrollIntoView({ behavior: "smooth", block: "start" })
                            }}>
                            <StyledReactSVG path={AttributeIcon} />
                            {t('Attributes')}
                        </SideButton>
                        <SideButton
                            onClick={() => {
                                window.history.back();
                            }}
                            visible={true}
                            style={{
                                height: '25px',
                                width: '50px',
                                position: 'absolute',
                                left: '5px',
                                bottom: '5px',
                            }}>
                            {t('Back')}
                        </SideButton>
                    </AdminSide>
                    <AdminContent>
                        {this.state.loading
                            ? <StyledSpinner />
                            : <React.Fragment>
                                <div ref={(node) => { this.projectTab = node }}>
                                    <PanelHeader>
                                        *** {t('Projects')} ***
                                    </PanelHeader>
                                </div>
                                <PanelWrapper>
                                    <ProjectAdmin
                                        chosenCustomer={chosenCustomer}
                                        projects={projects}
                                        getProjects={this.getProjects.bind(this)}
                                        roles={roles} />
                                </PanelWrapper>
                                <div ref={(node) => { this.userTab = node }}>
                                    <PanelHeader>
                                        *** {t('Users')} ***
                                    </PanelHeader>
                                </div>
                                <PanelWrapper>
                                    <UserAdmin
                                        chosenCustomer={chosenCustomer}
                                        users={users}
                                        projects={projects}
                                        getProjects={this.getProjects.bind(this)}
                                        getUsers={this.getUsers.bind(this)} />
                                </PanelWrapper>
                                {roles === 'SuperAdmin'
                                    ? <React.Fragment>
                                        <div ref={(node) => { this.customerTab = node }}>
                                            <PanelHeader>
                                                *** {t('Customers')} ***
                                            </PanelHeader>
                                        </div>
                                        <PanelWrapper>
                                            <CustomerAdmin
                                                customers={customers}
                                                instances={instances}
                                                getCustomers={this.getCustomers.bind(this)} />
                                        </PanelWrapper>
                                    </React.Fragment>
                                    : null}
                                {roles === 'SuperAdmin'
                                    ? <React.Fragment>
                                        <div ref={(node) => { this.instancesTab = node }}>
                                            <PanelHeader>
                                                *** {t('Instances')} ***
                                            </PanelHeader>
                                        </div>
                                        <PanelWrapper>
                                            <InstanceAdmin
                                                instances={instances}
                                                getInstances={this.getInstances.bind(this)} />
                                        </PanelWrapper>
                                    </React.Fragment>
                                    : null}
                                {roles === 'SuperAdmin'
                                ? <React.Fragment>
                                    <div ref={(node) => { this.statisticsTab = node }}>
                                        <PanelHeader>
                                            *** {t('Statistics')} ***
                                        </PanelHeader>
                                    </div>
                                    <PanelWrapper>
                                        <UserAssigmentAdmin userAssignmentList={userAssignments}/>
                                    </PanelWrapper>
                                </React.Fragment>
                                : null}
                                <div ref={(node) => { this.attributeTab = node }}>
                                    <PanelHeader>
                                        *** {t('Attributes')} ***
                                    </PanelHeader>
                                </div>
                                <PanelWrapper style={{ height: 'calc(100% - 107px)' }}>
                                    <ProjectAttributes
                                        chosenCustomer={chosenCustomer} />
                                </PanelWrapper>
                            </React.Fragment>
                        }
                    </AdminContent>
                </AdminBody>
            </AdminWrapper>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(AdminPanel));


// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/AdminPanel.jsx